module.exports = __webpack_public_path__ + "img/burger.57e8bb46.svg";